"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../../constants/gameWidth"));
const drawImage_1 = __importDefault(require("./drawImage"));
const drawVictory = () => {
    (0, drawImage_1.default)("victory", 1, 0, 0, gameWidth_1.default, gameHeight_1.default, 0, 0, gameWidth_1.default, gameHeight_1.default, null);
};
exports.default = drawVictory;
